import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        }
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('postfix/domains', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('postfix/domains', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`postfix/domains/${payload.domain}`, payload);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`postfix/domains/${id}/activate`);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`postfix/domains/${id}/deactivate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`postfix/domains/${id}`);

            return response;
        }
    }
}